import type { RouteLocationRaw } from 'vue-router'

// An outside page (opens in a new tab) or an in-app route — never both.
export type FooterLink =
    | { label: string; href: string; to?: never }
    | { label: string; to: RouteLocationRaw; href?: never }

export type FooterColumnId = 'company' | 'apps' | 'shop' | 'premium' | 'legal'

export interface FooterColumn {
    id: FooterColumnId
    heading: string
    links: FooterLink[]
}

export interface FooterSocial {
    id: string
    label: string
    icon: string
    href: string
}

// Shown to logged-out and free listeners only; subscribers never see it.
export const PREMIUM_COLUMN_ID: FooterColumnId = 'premium'

// Footer content design 1218330348150497 (approved 2026-09-18), Figma Footer 511:229.
// Array order is render order at every tier.
export const FOOTER_COLUMNS: FooterColumn[] = [
    {
        id: 'company',
        heading: 'Company',
        links: [
            { label: 'About', href: 'https://frisky.fm/about' },
            { label: 'Support', href: 'https://frisky.fm/support' },
            { label: 'Product News', href: 'https://friskyfm.substack.com/' },
        ],
    },
    {
        id: 'apps',
        heading: 'Apps',
        links: [
            { label: 'FRISKY for iOS', href: 'https://apps.apple.com/us/app/frisky-electronic-music/id524174564' },
            { label: 'FRISKY for Android', href: 'https://play.google.com/store/apps/details?id=com.frisky.radio.v2' },
        ],
    },
    {
        id: 'shop',
        heading: 'Shop',
        links: [{ label: 'FRISKY Store', href: 'https://friskyfm.myshopify.com/' }],
    },
    {
        id: PREMIUM_COLUMN_ID,
        heading: 'Premium',
        links: [{ label: 'Get Premium', to: { name: 'premium/view-plans', query: { from: 'footer' } } }],
    },
    {
        id: 'legal',
        heading: 'Legal',
        links: [
            { label: 'Privacy Policy', href: 'https://frisky.fm/about/privacy-policy' },
            { label: 'Terms of Use', href: 'https://frisky.fm/about/terms' },
        ],
    },
]

// Instagram/Facebook confirmed by Faisal 2026-09-18 (D6); YouTube 2026-09-17. X stays share-only (T1).
export const FOOTER_SOCIAL: FooterSocial[] = [
    { id: 'threads', label: 'Threads', icon: 'logo-threads', href: 'https://www.threads.com/@friskyradio' },
    { id: 'instagram', label: 'Instagram', icon: 'logo-instagram', href: 'https://www.instagram.com/friskyradio/' },
    { id: 'facebook', label: 'Facebook', icon: 'logo-facebook', href: 'https://www.facebook.com/friskyradio' },
    { id: 'youtube', label: 'YouTube', icon: 'logo-youtube', href: 'https://www.youtube.com/@FRISKYfm' },
]
